import React from "react";
import cx from "classnames";
import LinesEllipsis from "react-lines-ellipsis";
import responsiveHOC from "react-lines-ellipsis/lib/responsiveHOC";
import useMeasure from "react-use-measure";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

import styles from "./text.module.scss";

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

export const Text = ({
  text,
  lines = 1,
  className,
  tooltip = true,
  width = null,
}) => {
  const [ref, bounds] = useMeasure();
  const [clamped, setClamped] = React.useState(false);

  const onReflow = React.useCallback((r) => {
    setClamped(r.clamped);
  }, []);

  const content = (
    <ResponsiveEllipsis
      text={text}
      maxLine={lines}
      ellipsis="…"
      trimRight
      basedOn="letters"
      onReflow={onReflow}
    />
  );

  const wrappedContent =
    tooltip && clamped ? (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-username" className="tooltip-name">
            {text}
          </Tooltip>
        }
      >
        <div className={styles.innerTooltip}>{content}</div>
      </OverlayTrigger>
    ) : (
      content
    );

  return (
    <div
      ref={ref}
      className={cx(styles.text, className)}
      // style={width ? { width: `${width}%` } : {}}
    >
      {wrappedContent}
    </div>
  );
};

export default React.memo(Text);
